/**
 * Aviso "N listas apagadas" (proposta "Delete", 17/10/2026): aparece embaixo, no centro, por
 * alguns segundos depois de apagar. Serve aos fluxos de apagar e aos avisos curtos do histórico
 * do LeadExplorer — os avisos globais (uiStore.pushNotice) continuam desligados desde 22/08/2026.
 * O componente fica em DeleteToastHost.tsx.
 */
import { create } from 'zustand';

interface DeleteToastState {
  message: string | null;
  stamp: number;
  /** Ícone do aviso: o visto para o que deu certo, `info` para o que só explica. */
  icon: string;
}

export const useDeleteToastStore = create<DeleteToastState>(() => ({
  message: null,
  stamp: 0,
  icon: 'check_circle',
}));

export function showDeleteToast(message: string, icon = 'check_circle'): void {
  useDeleteToastStore.setState({ message, stamp: Date.now(), icon });
}
